module.exports = __webpack_public_path__ + "static/media/analysis-macrovector-01 6.874e4baa.png";